export type PictoName =
  | 'absences_picto'
  | 'absences_submission'
  | 'absences_validation'
  | 'account_balance'
  | 'account_multiple'
  | 'add'
  | 'analytics'
  | 'arrow'
  | 'arrow_circle_right'
  | 'arrow_downward_alt'
  | 'arrow_drop_down'
  | 'arrow_drop_up'
  | 'arrow_left'
  | 'arrow_left_alt'
  | 'arrow_right'
  | 'arrow_right_alt'
  | 'arrow_upward_alt'
  | 'automation'
  | 'automation_stroke'
  | 'bank'
  | 'bolt'
  | 'book'
  | 'calculate_stroke'
  | 'calculator_picto'
  | 'cancel'
  | 'centralization'
  | 'chat_bubble'
  | 'check'
  | 'check_circle'
  | 'check_box'
  | 'check_box_outline'
  | 'chevron'
  | 'chevron_left'
  | 'chevron_right'
  | 'clear'
  | 'company'
  | 'contact_support'
  | 'contact_support_stroke'
  | 'contract_edit'
  | 'costs'
  | 'Creators'
  | 'dashboard'
  | 'decla'
  | 'dematerialisation'
  | 'description'
  | 'document_check'
  | 'donation'
  | 'donut_large'
  | 'download'
  | 'dropdown'
  | 'earth'
  | 'economic'
  | 'edit'
  | 'edit_document_stroke'
  | 'employee_space'
  | 'empty'
  | 'event_available_stroke'
  | 'exports'
  | 'favorite'
  | 'filter_list'
  | 'flexibility'
  | 'fluidification'
  | 'fluidity'
  | 'format_letter_spacing'
  | 'forum'
  | 'gavel_stroke'
  | 'good_practices'
  | 'group'
  | 'help'
  | 'help_box_multiple'
  | 'history_stroke'
  | 'home'
  | 'home_storage'
  | 'human'
  | 'immediacy'
  | 'info'
  | 'info_outline'
  | 'info_square'
  | 'keyboard_arrow_down'
  | 'keyboard_arrow_up'
  | 'language'
  | 'legal'
  | 'less'
  | 'list'
  | 'lock'
  | 'login'
  | 'manage_accounts'
  | 'manage_accounts_stroke'
  | 'manager_space'
  | 'manager_validation'
  | 'medical_services_stroke'
  | 'menu'
  | 'money'
  | 'monitoring_stroke'
  | 'more'
  | 'more_vertical'
  | 'new_integration'
  | 'notifications_active'
  | 'objectives'
  | 'onboarding'
  | 'organization_chart'
  | 'other_question'
  | 'palette'
  | 'payments_stroke'
  | 'pending_actions_stroke'
  | 'person'
  | 'person_add_stroke'
  | 'person_remove_stroke'
  | 'personal_injury'
  | 'personalize'
  | 'play'
  | 'play_arrow'
  | 'play_arrow_filled'
  | 'playlist_add_check'
  | 'plus'
  | 'puzzle'
  | 'question'
  | 'quickly'
  | 'reliability'
  | 'remove'
  | 'remuneration'
  | 'request_expense'
  | 'rights'
  | 'rounded_corner'
  | 'schedule_send'
  | 'school'
  | 'search'
  | 'security'
  | 'shield_person'
  | 'signature'
  | 'simplicity'
  | 'smartphone_stroke'
  | 'sort'
  | 'speed'
  | 'star'
  | 'storefront'
  | 'support'
  | 'support_icon'
  | 'sync'
  | 'sync_alt_stroke'
  | 'tax_advisors'
  | 'templates'
  | 'text_format'
  | 'thumb_up'
  | 'time_check'
  | 'time_tracking'
  | 'time_validation'
  | 'timeline'
  | 'timer'
  | 'to_remember'
  | 'transparency'
  | 'tune_stroke'
  | 'unfold_less'
  | 'unfold_more'
  | 'unified'
  | 'upload'
  | 'verified_stroke'
  | 'view'
  | 'visibility'
  | 'visibility_stroke'
  | 'wallet_bifold'
  | 'warning'
  | 'whatsapp'
  | 'work'
  | 'work_fill';

export const pictosLibrary: PictoName[] = [
  'absences_picto',
  'absences_submission',
  'absences_validation',
  'account_balance',
  'account_multiple',
  'add',
  'analytics',
  'arrow',
  'arrow_circle_right',
  'arrow_downward_alt',
  'arrow_drop_down',
  'arrow_drop_up',
  'arrow_left',
  'arrow_left_alt',
  'arrow_right',
  'arrow_right_alt',
  'arrow_upward_alt',
  'automation',
  'automation_stroke',
  'bank',
  'bolt',
  'book',
  'calculate_stroke',
  'calculator_picto',
  'cancel',
  'centralization',
  'chat_bubble',
  'check',
  'check_circle',
  'check_box',
  'check_box_outline',
  'chevron',
  'chevron_left',
  'chevron_right',
  'clear',
  'company',
  'contact_support',
  'contact_support_stroke',
  'contract_edit',
  'costs',
  'Creators',
  'dashboard',
  'decla',
  'dematerialisation',
  'description',
  'document_check',
  'donation',
  'donut_large',
  'download',
  'dropdown',
  'earth',
  'economic',
  'edit',
  'edit_document_stroke',
  'employee_space',
  'empty',
  'event_available_stroke',
  'exports',
  'favorite',
  'filter_list',
  'flexibility',
  'fluidification',
  'fluidity',
  'format_letter_spacing',
  'forum',
  'gavel_stroke',
  'good_practices',
  'group',
  'help',
  'help_box_multiple',
  'history_stroke',
  'home',
  'home_storage',
  'human',
  'immediacy',
  'info',
  'info_outline',
  'info_square',
  'keyboard_arrow_down',
  'keyboard_arrow_up',
  'language',
  'legal',
  'less',
  'list',
  'lock',
  'login',
  'manage_accounts',
  'manage_accounts_stroke',
  'manager_space',
  'manager_validation',
  'medical_services_stroke',
  'menu',
  'money',
  'monitoring_stroke',
  'more',
  'more_vertical',
  'new_integration',
  'notifications_active',
  'objectives',
  'onboarding',
  'organization_chart',
  'other_question',
  'palette',
  'payments_stroke',
  'pending_actions_stroke',
  'person',
  'person_add_stroke',
  'person_remove_stroke',
  'personal_injury',
  'personalize',
  'play',
  'play_arrow',
  'play_arrow_filled',
  'playlist_add_check',
  'plus',
  'puzzle',
  'question',
  'quickly',
  'reliability',
  'remove',
  'remuneration',
  'request_expense',
  'rights',
  'rounded_corner',
  'schedule_send',
  'school',
  'search',
  'security',
  'shield_person',
  'signature',
  'simplicity',
  'smartphone_stroke',
  'sort',
  'speed',
  'star',
  'storefront',
  'support',
  'support_icon',
  'sync',
  'sync_alt_stroke',
  'tax_advisors',
  'templates',
  'text_format',
  'thumb_up',
  'time_check',
  'time_tracking',
  'time_validation',
  'timeline',
  'timer',
  'to_remember',
  'transparency',
  'tune_stroke',
  'unfold_less',
  'unfold_more',
  'unified',
  'upload',
  'verified_stroke',
  'view',
  'visibility',
  'visibility_stroke',
  'wallet_bifold',
  'warning',
  'whatsapp',
  'work',
  'work_fill',
];
